import React from "react";
import { withRouter } from "react-router-dom"; 
import axios from "axios";
class QuicksearchOption extends React.Component {
  navigate = (mealtype) => {
    this.props.history.push(`./filter?mealtype=${mealtype}`);
  };
  componentDidMount(){
  axios.get("https://z-5dan.onrender.com/getallmealtype")
           .then(response => {
               this.setState({ restaurants:response.data });
           })
           .catch(error => {
               console.error('Error fetching location data:', error);
           });
         };
    render() {
    const { name, content, image,meal_type} = this.props.quicksearchitemData;
    return (
      <div>
        <div class="titleContainer" onClick={() => this.navigate(meal_type)}> 
    
          <div class="titleComp1">
            <img src={`${image}`} alt="dinner" height="150" width="140" />
          </div>
          <div>
            <div class="compHeading">{name}</div>
            <div class="compsubHeading">{content}</div>
          </div>
        </div>

      </div>
   
    );
  }
}

export default withRouter(QuicksearchOption); 
